// extracted by mini-css-extract-plugin
export default {"tooltipWpapper":"TooltipGlodal_tooltipWpapper__F6Lc-"};